import { render, staticRenderFns } from "./PetAppointmentConflict.vue?vue&type=template&id=ed28c6dc"
import script from "./PetAppointmentConflict.vue?vue&type=script&lang=js"
export * from "./PetAppointmentConflict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports